import { PATCH_CUSTOMER_SUCCESS } from '../constants';
import {
    GET_NEWLY_ASSIGNED_CUSTOMERS,
    GET_NEWLY_ASSIGNED_CUSTOMERS_ERROR,
    GET_NEWLY_ASSIGNED_CUSTOMERS_SUCCESS,
} from './actions';

const newlyAssignedCustomersReducer = (
    state = {
        items: [],
        loading: false,
        loadError: false,
    },
    action
) => {
    switch (action.type) {
        case GET_NEWLY_ASSIGNED_CUSTOMERS:
            return {
                ...state,
                items: [],
                loading: true,
                loadError: false,
            };

        case GET_NEWLY_ASSIGNED_CUSTOMERS_SUCCESS:
            return {
                ...state,
                items: action.data,
                loading: false,
            };

        case GET_NEWLY_ASSIGNED_CUSTOMERS_ERROR:
            return {
                ...state,
                loading: false,
                loadError: action.error,
            };

        case PATCH_CUSTOMER_SUCCESS:
            return {
                ...state,
                items: state.items
                    .filter(
                        customer =>
                            customer.id !== Number.parseInt(action.data.request.id, 10) ||
                            !action.data.request.values.employeeAssignedConfirmedAt
                    )
                    .map(customer =>
                        customer.id !== Number.parseInt(action.data.request.id, 10)
                            ? customer
                            : {
                                  ...customer,
                                  ...action.data.request.values,
                              }
                    ),
            };

        default:
            return state;
    }
};

export default newlyAssignedCustomersReducer;
